<template>
  <a href="#" ref="copyToClipboard" class="copy-link" @click.prevent="sendTrackEvent" :data-clipboard-text="value" data-testid="copy-link-to-clipboard">
    <span class="label">{{this.label}}</span>
    <span class="hover-message">Copy link to clipboard</span>
    <img :src="require('@img/icons-clipboard.svg')" />
  </a>
</template>

<style scoped lang="scss">
@import "@/packs/colors.scss";

.hover-message {
  display: none;
}

.copy-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 8px 0;
  border-radius: 4px;
  color: $bright-blue;

  &:hover {
    text-decoration: none;
    background-color: $solitude;

    .label { display: none; }
    .hover-message { display: inline-block; }
  }

  img {
    margin-left: 5px;
    vertical-align: baseline;
  }
}
</style>

<script>
import ClipboardJS from 'clipboard'
import track from '@/src/tracking';

export default {
  mounted() {
    const vm = this;
    if (vm.container) {
      // This is used because ClipboardJS relies on the currently focused element. If loaded from within a
      // bootstrap modal, pass its id. It would be ideal if we could pass a ref or element instead of an
      // id, but not sure if that's a thing.
      vm.clipboard = new ClipboardJS(vm.$refs.copyToClipboard, { container: document.getElementById(vm.container) });
    } else {
      vm.clipboard = new ClipboardJS(vm.$refs.copyToClipboard);
    }

    vm.clipboard.on('success', () => vm.showToast('success'));
    vm.clipboard.on('error', () => vm.showToast('error'));
  },
  props: {
    value: String,
    label: String,
    container: String,
  },
  data: function() {
    return {
      clipboard: null,
      toastShown: false
    }
  },
  computed: {
    message: function () {
      return "Copy link";
    },
  },
  methods: {
    showToast: function(type){
      const vm = this;
      if(!vm.toastShown){
        vm.toastShown = true;

        if(type == 'success'){
          vm.$root.toastSuccess("Share link copied to clipboard")
        }else if(type == 'error') {
          vm.$root.toastError("Could not copy share link");
        }

        // toasts dissapear after 3000 ms + fading
        setTimeout(() => vm.toastShown = false, 3500)
      }
    },
    sendTrackEvent: function () {
      track('viewer_copy_link_click', { source: "new_copy_viewer" });
    },
  }
}
</script>
